
import Teleport from 'vue2-teleport';
import addressMixin from '@/mixins/addressMixin.js';
import carriersMixin from '@/mixins/carriersMixin.js';
import cartMixin from '@/mixins/cartMixin.js';
import { TunnelHelper } from '@/helpers/TunnelHelper.js';
import { mapState } from 'vuex';
import { Drawer, Button } from 'element-ui';

export default {
  name: 'CheckoutCarriersCard',
  mixins: [addressMixin, carriersMixin, cartMixin],

  props: {
    carrier: {
      type: Object,
      required: true,
    },
    carrierType: {
      type: String,
      required: true,
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      relayPoints: [],
      drawer: false,
      direction: 'rtl',
      drawerTitle: '',
      mapSelected: 'CarriersMap',
      loading: false,
    };
  },
  computed: {
    ...mapState('checkout', [
      'shippingAddress',
      'invoiceAddress',
      'checkoutRelayPoint',
    ]),
    currencyIsoCode() {
      return this.$localisation.appCurrency.CurrencyIsoCode;
    },
    active() {
      return this.cartCarriers?.IdCarrier === this.carrier.IdCarrier;
    },
  },
  methods: {
    onCardClick() {
      this.setCarrier();
      this.scrollToPayment();
    },
    scrollToPayment() {
      this.$nextTick(() => {
        setTimeout(() => {
          const el = document.querySelector('.checkoutPayment');
          const header = document.querySelector('.header-tunnel');
          if (el) {
            const headerHeight = header ? header.offsetHeight : 0;
            const elementPosition =
              el.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = elementPosition - headerHeight - 20;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth',
            });
          }
        }, 500);
      });
    },
    getCarrierImage() {
      const name = this.carrier.Name?.toLowerCase() || '';
      const map = {
        colissimo: 'colissimo.svg',
        dhl: 'dhl-logo.svg',
        chronopost: 'chronopost-logo.svg',
        gls: 'gls-logo.svg',
        ups: 'ups-logo.svg',
        'mondial relay': 'logomondial-relay-logo.svg',
      };
      const key = Object.keys(map).find((k) => name.includes(k));
      try {
        if (key) return require(`~/assets/img/logo/carrier/${map[key]}`);
        return require('~/assets/img/logo.svg');
      } catch (e) {
        try {
          return require(`~/assets/img/${map[key]}`);
        } catch (e) {
          return null;
        }
      }
    },
    async setCarrier(hasRelayPoint = false) {
      this.loading = true;
      this.$store.commit('checkout/setCarrierLoading', true);
      try {
        if (this.carrierType === 'RelayPoint' && !hasRelayPoint) {
          await this.getRelayPoints();
        }

        const params = {
          idCarrier: this.carrier.IdCarrier,
          idAddress: this.idAddressDelivery || this.shippingAddress?.IdAddress,
          idAddressInvoice:
            this.idAddressInvoice || this.invoiceAddress?.IdAddress,
          countryIsoCode: this.shippingAddress?.CountryIsoCode,
        };

        if (this.checkoutRelayPoint) {
          params.idRelayPoint = this.checkoutRelayPoint.Id;
          params.countryIsoCode =
            this.checkoutRelayPoint.CountryIsoCode || this.carrier.Country;
        }

        await this.cartService.setCarrierToCart(params);
        await this.cartService.fetchCart();
      } catch (error) {
        console.error('Carrier error', error);
      } finally {
        this.loading = false;
        this.$store.commit('checkout/setCarrierLoading', false);
      }
    },
    async getIp() {
      try {
        const res = await this.$store.dispatch('shop/localisation/fetchVisitor');
        return res.ip;
      } catch (e) {
        return null;
      }
    },
    async getRelayPoints() {
      const helper = new TunnelHelper(this.$http, this.$auth);
      try {
        if (!this.ip) this.ip = await this.getIp();
        let options = { languageIsoCode: this.$i18n.locale };

        const addr = this.shippingAddress;
        console.log('addr', addr);
        if (addr?.Address1 && addr?.Postcode && addr?.CountryIsoCode) {
          Object.assign(options, {
            postalCode: addr.Postcode,
            city: addr.City,
            address: addr.Address1,
            country: addr.Country || addr.CountryIsoCode,
            countryIsoCode: addr.CountryIsoCode,
            idCarrier: this.carrier.IdCarrier,
            carrierType: 'RelayPoint',
          });
        } else if (this.ip) {
          options.ip = this.ip;
        }
        const data = await helper.getRelayPointsByCityAndPostcode(options);

        this.relayPoints = data.RelayPoints || [];

        if (this.relayPoints.length > 0) {
          const stored =
            this.checkoutRelayPoint?.Id || this.cartRelayPoint?.IdRelayPoint;
          const target =
            this.relayPoints.find((rp) => rp.Id === stored) ||
            this.relayPoints[0];

          this.$store.commit('checkout/setCheckoutRelayPoint', {
            data: target,
          });
        }
      } catch (error) {
        console.error('Relay points error', error);
      }
    },
    openMap() {
      this.drawer = true;
      this.mapSelected = 'CarriersMap';
      this.drawerTitle = this.$t('Choose a relay point');
    },
    selectRelayPoint(relayPoint) {
      this.$store.commit('checkout/setCheckoutRelayPoint', {
        data: relayPoint,
      });
      this.setCarrier(true);
      this.drawer = false;
      this.scrollToPayment();
    },
  },
  async mounted() {
    if (this.carrierType === 'RelayPoint' && this.active) {
      await this.getRelayPoints();
      if (!this.cartRelayPoint?.IdRelayPoint) {
        await this.setCarrier(true);
      }
    }
  },
  components: {
    Drawer,
    Teleport,
  },
};
